import React, { useState } from "react";

const LeerArchivoTxt = ({ onContenidoChange, onPartidosArmadosChance }) => {
  //const [contenidoArchivo, setContenidoArchivo] = useState("");

  const manejarCambioArchivo = (event) => {
    const archivo = event.target.files[0];

    if (archivo) {
      const lector = new FileReader();

      lector.onload = (e) => {
        const contenido = e.target.result;
        const texto = contenido.replace(/(\r\n|\r)/g, "\n");
        const partidosJson = [];

        // Separar el texto en líneas utilizando el carácter de salto de línea (\n)
        const lineas = texto.split("\n");
        lineas.map((linea, index) => {
          const equipos = linea.split("|");
          // const json = {
          //   equipoSeleccionado1: equipos[0],
          //   equipoSeleccionado2: equipos[1],
          // };
          const json = {
            equipoSeleccionado1: { Nombre: equipos[0] },
            equipoSeleccionado2: { Nombre: equipos[1] },
            indice: index,
          };
          partidosJson.push(json);
        });

        /*
        {"equipoSeleccionado1":{"id":null,"Nombre":equipos[0],"categoria":null,"comparteJugadores":null,"idTorneo":null},
        "equipoSeleccionado2":{"id":null,"Nombre":"Bombita 5","categoria":null,"comparteJugadores":null,"idTorneo":null}]
        */
        /*
        {"equipoSeleccionado1":{"Nombre":equipos[0]},
        "equipoSeleccionado2":{"Nombre":equipos[1]}}
        */

        onContenidoChange(partidosJson);

        onPartidosArmadosChance(partidosJson);
      };

      lector.readAsText(archivo);
    }
  };

  return (
    <div>
      <input type="file" onChange={manejarCambioArchivo} />
    </div>
  );
};

export default LeerArchivoTxt;
